<template>
    <div class="update-qwilr-definition">
      <h3>Update Definition</h3>
      <div class="form-group mb-4">
        <label for="definition-key" class="form-label">Definition Key</label>
        <input
          type="text"
          id="definition-key"
          class="form-control"
          v-model="definitionKey"
          placeholder="Enter definition key"
      />
      </div>
      <div class="form-group mb-4">
        <label for="definition-name" class="form-label">Definition Name</label>
        <input
          type="text"
          id="definition-name"
          class="form-control"
          v-model="definitionName"
          placeholder="Enter definition name"
      />
      </div>
      <div class="form-group mb-4">
        <label for="description" class="form-label">Description</label>
        <textarea
          id="description"
          class="form-control"
          v-model="description"
          placeholder="Enter description"
          rows="4"
        ></textarea>
      </div>
      <div class="form-buttons">
        <button class="btn btn-primary" @click="updateDefinition" :disabled="isBusy">
          <div v-if="isBusy">
              <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>

              Loading...
          </div>
          <div v-else>
            Update Definition
          </div>
        </button>
        <button class="btn btn-secondary" @click="$emit('close')">Cancel</button>
      </div>
    </div>
  </template>
  
  <script>
  import { UpdateQwilrDefinition } from '@/core/services/entities/qwilr.service'
  import { useToast } from 'vue-toastification'

  export default{
    name:"UpdateQwilrDefinition",
    props:{
        definition:{
            type:Object,
            required:true
        }
    },
    data(){
        return{
            description:'',
            definitionKey:'',
            definitionName:'',
            isBusy:false
        }
    },
    methods:{
        async updateDefinition(){
            this.isBusy = true;

            setTimeout(async () => {
              if (!this.validateFields()) {
                this.isBusy = false;
                return;
              }

              const toast = useToast();
              const payload = { id:this.definition.id, qwilrDefinitionKey:this.definitionKey, qwilrDefinitionName:this.definitionName, description:this.description};
          
              await UpdateQwilrDefinition(payload)
                      .then(response => {
                      if (response.status === 200) {
                          toast.success('Definition updated successfully!', {
                          timeout: 2000
                          })
                          this.isBusy = false;
                          this.$emit('definitionUpdated'); // Emit the event to notify the parent component
                          this.$emit('close'); // Close the lightbox after adding data stream
                      }
                      })
                      .catch(ex => {
                          this.isBusy = false;
                          const errorMessage = ex.response?.data || ex.message || "An unknown error occurred";
                          console.log(ex);
                          toast.error(`Failed to update definition : ${errorMessage}`, {timeout: 2000,});
                      })
            }, 500);

        },
        validateFields() {
          const toast = useToast();

          if (this.definitionKey.trim() === '') {
            toast.error('Definition key is required!', { timeout: 3000 });
            return false; 
          }

          if (this.definitionName.trim() === '') {
            toast.error('Definition name is required!', { timeout: 3000 });
            return false; 
          }

          return true; 
        }
    },
    created() {
        this.description=this.definition.description
        this.definitionKey=this.definition.qwilrDefinitionKey
        this.definitionName=this.definition.qwilrDefinitionName
    }
  }
 </script>
  
  <style scoped>
  .update-qwilr-definition {
    width: 600px; /* Double the size */
    height: 500px; /* Double the size */
    padding: 40px; /* Increase padding */
    background-color: #fff; /* Ensure background is white */
    border-radius: 8px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  }
  
  .form-group {
    margin-bottom: 1rem;
  }
  
  .form-label {
    display: block;
    margin-bottom: 0.5rem;
  }
  
  .form-control {
    width: 100%;
    padding: 0.5rem;
    margin-bottom: 0.5rem;
  }
  
  .form-buttons {
    display: flex;
    justify-content: space-between;
    margin-top: 1rem;
  }
  
  .btn {
    padding: 0.5rem 1rem;
  }
  
  .btn-secondary {
    background-color: #6c757d;
    color: #fff;
  }
  
  .btn-secondary:hover {
    background-color: #5a6268;
  }
  </style>
  